module.exports = __webpack_public_path__ + "img/05.f3985fda.png";